module.exports = __webpack_public_path__ + "img/caja.86273ceb.svg";